import { render } from "./TestPanel.vue?vue&type=template&id=9b10c19a"
import script from "./TestPanel.vue?vue&type=script&lang=js"
export * from "./TestPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__